module.exports = __webpack_public_path__ + "static/img/3-6.8.5.7d7386a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.8.5.png
// module id = Ecly
// module chunks = 0